import { render, staticRenderFns } from "./UserAgreementDialog.vue?vue&type=template&id=238ec464&scoped=true"
import script from "./UserAgreementDialog.vue?vue&type=script&lang=js"
export * from "./UserAgreementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ec464",
  null
  
)

export default component.exports